/**
 * @ngdoc service
 * @name cbl.cartadebitoint.wa.directive:postVenditaCartaDebitoIntSrvc
 * @restrict E
 * @scope
 * @description Servizio che gestisce il processo di creazione nuova pratica e
 *              visualizzazione pratica esistente
 */
(function () {
  angular.module('cbl.cartadebitoint.wa').service('PostVenditaCartaDebitoIntSrvc', [
    '$http',
    '$q',
    'CdintMessaggiFctr',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    function ($http, $q, messaggiFctr, CONSTANTS, labelSrvc) {
      this.$http = $http;
      this.$q = $q;
      this.messaggiFctr = messaggiFctr;
      this.labelSrvc = labelSrvc;
      this.CONSTANTS = CONSTANTS;

      /**
       * Variabile per la gestione dello spinner
       */
      this.spinner = { showSpinner: 0 };

      /**
       * Dati della pratica, presenti anche nel componente cdintPropostaCartaDebitoInt
       */
      this.datiPratica;

      /**
       * elenco delle carte recuperate dall'MF per ndg.
       */
      this.elencoCarte;

      /**
       * anagrafica di riferimento
       */
      this.anagrafica;

      /**
       * elenco delle funzioni
       */
      this.elencoFunzioni;

      /**
       * carta selezionata
       */
      this.currentCarta;

      /**
       * funzione selezionata.
       */
      this.currentFunzione;

      /**
       * funzione currentBlocco.
       */
      this.currentBlocco;

      /**
       * Dati valorizzati per il secondo step
       */
      this.datiAggiuntivi;

      /**
       * Definizione ndg
       */
      this.ndg;

      /**
       * Definizione id Target Market
       */
      this.idTargetMarket;

      /**
       * Definizione id pratica
       */
      this.idPratica;

      /**
       * Elenco dei conti per ndg.
       */
      this.elencoConti;

      /**
       * conto selezionato
       */
      this.currentConto;

      /**
       * Riferimento interno
       */
      var self = this;

      this.resetData = function () {
        self.elencoCarte = null;
        self.anagrafica = null;
        self.elencoFunzioni = null;
        self.currentCarta = null;
        self.currentFunzione = null;
        self.currentBlocco = null;
        self.ndg = null;
        self.elencoConti = null;
        self.currentConto = null;
        self.currentBlocco = null;
      };

      /**
       * Utility di formattazione date
       */
      this.millisToDate = function (milliseconds) {
        var data = new Date(milliseconds);

        if (!data) {
          return null;
        }

        var day = data.getDate();
        var month = data.getMonth() + 1;
        var year = data.getFullYear();

        return (
          (day < 10 ? '0' + day.toString() : day.toString()) +
          '/' +
          (month < 10 ? '0' + month.toString() : month.toString()) +
          '/' +
          year.toString()
        );
      };

      /**
       * Utility per separare il numero civico dall'indirizzo
       */
      this.civicoDaIndirizzo = function (indirizzo) {
        if (!(indirizzo && indirizzo.trim().length > 0)) {
          return null;
        }

        // split per ' ' (spazio)
        var viaSplit = indirizzo.split(' ');
        var splitIndex = -1;

        for (var i = 0; i < viaSplit.length; i++) {
          if (!isNaN(viaSplit[i])) {
            splitIndex = indirizzo.indexOf(viaSplit[i]);
            break;
          }
        }

        if (splitIndex >= 0) {
          return indirizzo.substring(splitIndex);
        }

        // split per ','
        viaSplit = indirizzo.split(',');
        splitIndex = -1;

        for (var i = 0; i < viaSplit.length; i++) {
          if (!isNaN(viaSplit[i])) {
            splitIndex = indirizzo.indexOf(viaSplit[i]);
            break;
          }
        }

        if (splitIndex >= 0) {
          return indirizzo.substring(splitIndex);
        }

        return null;
      };

      /**
       * Indica se la pratica è in sola lettura
       */
      this.praticaIsReadOnly = function () {
        if (!self.datiPratica) {
          return false;
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
            return true;
          default:
            return false;
        }
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione pulsante indietro. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultIndietroAbilitato = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultSalvaVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultProseguiVisibile = function () {
        return true;
      };

      /**
       * Funzione di default assegnata alla gestione visualizzazione indietro. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultIndietroVisibile = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione salvataggio. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultSalvaAbilitato = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione proseguimento. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultProseguiAbilitato = function () {
        return false;
      };

      /**
       * Funzione di default assegnata alla gestione abilitazione indietro. Viene reimpostata ad ogni passaggio di stato
       */
      this.defaultIndietroAbilitato = function () {
        return true;
      };

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "indietro" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default permette di tornare indietro
       */
      this.indietroAbilitato = this.defaultIndietroAbilitato;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "salva" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette il salvataggio
       */
      this.salvaVisibile = this.defaultSalvaVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "prosegui" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di preseguire
       */
      this.proseguiVisibile = this.defaultProseguiVisibile;

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "annulla" nel componente postVenditaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default permette di annullare se la pratica non è in sola lettura
       */

      this.annullaVisibile = function () {
        return !self.praticaIsReadOnly();
      };

      /**
       * Questa variabile ospita la funzione che visualizza o meno il pulsante "completa" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette di completare
       */
      this.completaVisibile = function () {
        if (!self.datiPratica) {
          return false;
        }

        switch (self.datiPratica.stato) {
          case CONSTANTS.STATO_PRATICA.ACCETTATA:
          case CONSTANTS.STATO_PRATICA.ANNULLATA:
          case CONSTANTS.STATO_PRATICA.IN_CORSO:
            return false;
          case CONSTANTS.STATO_PRATICA.CONSOLIDATA:
          case CONSTANTS.STATO_PRATICA.PRESENTATA:
            return true;
          default:
            return false;
        }
      };
      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "salva" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette il salvataggio
       */
      this.salvaAbilitato = this.defaultSalvaAbilitato;

      /**
       * Questa variabile ospita la funzione che abilita o meno il pulsante "prosegui" nel componente cdintPropostaCartaDebitoInt
       * La funzione è creata e assegnata nei vari sotto-componenti. Di default non permette l'avanzamento
       */
      this.proseguiAbilitato = this.defaultProseguiAbilitato;

      /**
       * @ngdoc method
       * @name isPraticaNavigabile
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Verifica se lo stato della pratica permette la navigazione tramite click sui tab
       * @return {Boolean} - True se la pratica è navigabile, false in caso contrario
       */
      this.isPraticaNavigabile = function () {
        return self.praticaIsReadOnly();
      };

      /**
       * @ngdoc method
       * @name generaTabs
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Genera l'elenco delle tabs da visualizzare per la pratica
       * @return {Array} - Ritorna l'elenco delle tab disponibili per la pratica
       */
      this.generaTabs = function (hasProsegui) {
        var tabs = [];

        tabs.push({
          step: 'DEFINIZIONE',
          label: 'label.tab.postvendita.funzioni',
          posizione: '1',
          statoPratica: [
            {
              stato: 'DAREVISIONARE',
              step: 1
            },
            {
              stato: 'INCORSO',
              step: 1
            }
          ],
          sottoStep: null
        });

        if (hasProsegui) {
          tabs.push({
            step: 'DATIAGGIUNTIVI',
            label: 'label.tab.postvendita.dettagli',
            posizione: '2',
            statoPratica: [
              {
                stato: 'INCORSO',
                step: 2
              }
            ],
            sottoStep: null
          });
        }

        return tabs;
      };

      /**
       * Chiama servizio per recuperare i dati di una pratica già avviata
       * @param idPratica Id della pratica da recueperare
       */
      this.promiseRecuperaDati = function (idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.RECUPERA + idPratica
        });
      };

      /**
       * @ngdoc method
       * @name promiseCreaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per creare la pratica
       * @return {Promise} - Ritorna una promise contenente l'id della pratica appena creata
       */
      this.promiseCreaPratica = function (
        ndg,
        carta,
        funzione,
        conto,
        nuovaIntestazione,
        tipoBlocco,
        importoQuota,
        cdMotivo,
        limiteGiornaliero,
        limiteMensile,
        downOption,
        idPratica,
        cartaLight,
        numeroRapporto,
        indirizzoSpedizione
      ) {
        // parametri fissi
        var data = {
          ndg: ndg,
          numeroCarta: carta,
          funzione: funzione,
          iban: conto,
          nuovaIntestazione: nuovaIntestazione,
          // Nexi prevede che se tipoBlocco non è settato, allora gli venga passato uno spazio vuoto
          // invece di passare null
          tipoBlocco: tipoBlocco ? tipoBlocco : ' ',
          importoQuota: importoQuota,
          codiceMotivo: cdMotivo,
          limiteGiornaliero: limiteGiornaliero,
          limiteMensile: limiteMensile,
          downOption: downOption,
          idPratica: idPratica,
          cartaLight: cartaLight,
          numeroRapporto: numeroRapporto,
          indirizzoSpedizione: indirizzoSpedizione
        };

        return this.$http({
          method: 'POST',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.CREA,
          data: data
        });
      };

      /**
       * @ngdoc method
       * @name promiseDettaglioPratica
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare il dettaglio pratoca
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDettaglioPratica = function (ndg, idPratica) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.DETTAGLIO + ndg + '/' + idPratica
        });
      };

      /**
       * recupero dell'elenco delle carte da ndg
       * @param {*} idPratica
       */
      this.promiseElencoCarte = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.CARTA_NDG + ndg
        });
      };

      /**
       * recupero dell'elenco delle carte da ndg
       * @param {*} idPratica
       */
      this.promiseElencoConti = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.CONTI_NDG + ndg + '/true'
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaFunzioni
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaFunzioni = function () {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.FUNZIONI
        });
      };

      /**
       * @ngdoc method
       * @name promiseAnnullaPostVendita
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per annullare una pratica in postVendita
       * @return {Promise} - Ritorna una promise contenente il result dell'annullamento
       */
      this.promiseAnnullaPostVendita = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.POST_VENDITA.ANNULLA.replace('{id}', idPratica)
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaFunzioni
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati aggiuntivi salvati per l'anagrafica
       * @return {Promise} - Ritorna una promise contenente i dati aggiuntivi collegati alla pratica
       */
      this.promiseRecuperaDominio = function (FUNC) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + FUNC
        });
      };

      /**
       * @ngdoc method
       * @name promiseDatiAggiuntivi
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per eseguire la conferma dell'indirizzo di spedizione
       * @return {Promise} - Ritorna una promise contenente l'oggetto pratica collegato all'ID
       */
      this.promiseDatiAggiuntivi = function (idPratica, datiAggiuntivi, prosegui, sottostep) {
        var paramsObj = {
          prosegui: prosegui
        };

        if (sottostep && sottostep > 0) {
          paramsObj.sottostep = sottostep;
        }

        return this.$http({
          method: 'PUT',
          url:
            CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.DATI_AGGIUNTIVI,
          data: datiAggiuntivi,
          params: paramsObj
        });
      };

      /**
       * @ngdoc method
       * @name promiseCompletaPratica
       * @methodOf cbl.cartadebitoint.wa.directive:PostVenditaCartaDebitoIntSrvc
       * @description Effettua la chiamata per avviare il completamento della pratica
       * @return {Promise} - Ritorna una promise contenente la pratica aggiornata
       */
      this.promiseCompletaPratica = function (idPratica) {
        return this.$http({
          method: 'PUT',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICA.DETTAGLIO + idPratica + CONSTANTS.REST.PRATICA.COMPLETA,
          data: {
            idPratica: idPratica
          }
        });
      };

      /**
       * @ngdoc method
       * @name promiseRecuperaAnagraficaCoi
       * @methodOf cbl.cartadebitoint.wa.directive:CdintPropostaCartaDebitoIntSrvc
       * @description Effettua una chiamata http per recuperare i dati dell'anagrafica della pratica
       * @return {Promise} - Ritorna una promise contenente la lista degli ndg anche delle COI
       */
      this.promiseRecuperaAnagraficaCoi = function (ndg) {
        return this.$http({
          method: 'GET',
          url: CONSTANTS.REST_ROOT + CONSTANTS.REST.ANAGRAFICA.DETTAGLIO_COI + ndg
        });
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/postVenditaCartaDebitoInt/postVenditaCartaDebitoIntSrvc.js
// module id = 19
// module chunks = 0